module.exports = __webpack_public_path__ + "img/introduceList1.79d45e99.jpg";